
<template>
  <div>
    <v-card
      style="borderRadius: 15px"
      @click="openGroup"
    >
      <div class="d-flex pa-3 align-center">
        <span>{{ group.group_name }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
        >
          <v-icon>
            {{ open_group ? "mdi-chevron-up" : "mdi-chevron-down" }}
          </v-icon>
        </v-btn>
      </div>
      <v-expand-transition>
        <div v-show="open_group">
          <step-list
            class="pa-3"
            :group_id="group.id"
          ></step-list>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: "GroupCard",
    components: {
      StepList: () => import("../steps/StepList.vue"),
    },
    props: {
      group: {
        type: Object,
        default: () => {}
      },
    },
    data() {
      return {
        open_group: false
      }
    },
    mounted () {
      this.checkGroupToExecute();
    },
    methods: {
      checkGroupToExecute() {
        if (this.group.id == this.group_to_execute) {
          this.open_group = true;
        }
      },
      openGroup() {
        this.open_group = !this.open_group;
      },
    },
    computed: {
      ...mapGetters({
        group_to_execute: "FlowExecution/groupToExecute"
      })
    },
    watch: {
      group_to_execute(nv, ov) {
        if (nv && nv != ov && nv == this.group.id) {
          this.open_group = true;
        } else if (nv && nv != this.group.id) {
          this.open_group = false;
        }
      }
    },
  }
</script>

<style scoped>

</style>